import React from 'react';

export default {
  not_found: (props) => (
    <div>
      <p className="error">An error occurred</p>
    </div>
  ),
};